import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-form-results-details',
    templateUrl: './form-results-details.component.html',
    styleUrls: ['./form-results-details.component.css'],
    standalone: false
})
export class FormResultsDetailsDialogComponent {
  @ViewChild('printSection', { static: false }) printSection!: ElementRef;
  docId = '';
  tridyId = '';
  widgetName = '';
  templateName = '';
  contentType = '';
  submittedAt = '';
  title = '';

  entries: Array<{ key: string; value: string }> = [];

constructor(
  @Inject(MAT_DIALOG_DATA) public data: any,
  private router: Router,
  private route: ActivatedRoute,
  private dialogRef: MatDialogRef<FormResultsDetailsDialogComponent>
) {
  const row = data.info ?? {};

  this.widgetName = data.widgetName ?? row.widgetId ?? '';
  this.templateName = data.templateName ?? row.passTemplateId ?? '';
  this.title = this.widgetName;
  this.contentType = data.contentType ?? row.contentType ?? '';

  this.docId = row.id ?? '';
  this.tridyId = row.tridyId ?? '';

  const dt = row.timeStamp?.toDate?.() ?? (row.timeStamp ? new Date(row.timeStamp) : null);
  this.submittedAt = dt ? dt.toLocaleString('de-DE') : '';

  const rawData = row?.data;

  if (rawData && typeof rawData === 'object' && !Array.isArray(rawData)) {
    this.entries = Object.entries(rawData)
      .sort(([a], [b]) => a.localeCompare(b, 'de'))
      .map(([key, val]) => ({ key, value: this.formatValue(val) }));
  } else if (Array.isArray(rawData)) {
    this.entries = rawData.map((val, idx) => ({ key: String(idx), value: this.formatValue(val) }));
  } else {
    this.entries = [];
  }
}

  dialogClose() {
    this.dialogRef.close([false]);
  }

  private formatValue(v: any): string {
    if (v === null || v === undefined) return '';
    if (typeof v === 'string') return v;
    if (typeof v === 'number' || typeof v === 'boolean') return String(v);

    if (v?.toDate && typeof v.toDate === 'function') {
      try { return v.toDate().toLocaleString('de-DE'); } catch {}
    }

    try { return JSON.stringify(v, null, 2); } catch { return String(v); }
  }

  printPDF() {
    const content = this.printSection?.nativeElement;
    if (!content) return;

    const printWindow = window.open('', '', 'width=900,height=650');
    if (!printWindow) return;

    // copy styles so it looks the same
    const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
      .map(el => el.outerHTML)
      .join('');

    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>${this.title}</title>
          ${styles}
          <style>
            body { padding: 24px; }
            table { width: 100%; border-collapse: collapse; }
            td { padding: 8px 6px; vertical-align: top; }
            tr { border-bottom: 1px solid #e0e0e0; }
            .subtitle { margin-top: 4px; }
          </style>
        </head>
        <body>
          ${content.outerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();

    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  }

  openTemplate() {
    const contextId = this.getContextId();
    const contentTypeId = this.contentType;
    const passTemplateId = this.data.info?.passTemplateId;

    if (!contextId || !contentTypeId || !passTemplateId) return;

    const urlTree = this.router.createUrlTree([
      '/home',
      contextId,
      'contentTypes',
      contentTypeId,
      'passTemplate',
      passTemplateId
    ]);

    const url = this.router.serializeUrl(urlTree);

    window.open(url, '_blank', 'noopener');
  }

  private getContextId(): string | null {
    let r: ActivatedRoute | null = this.route.root;
    while (r?.firstChild) {
      r = r.firstChild;
      if (r.snapshot.paramMap.has('contextId')) {
        return r.snapshot.paramMap.get('contextId');
      }
    }
    return null;
  }

}
